import { Box } from "@mui/material";
import { FC } from 'react';
import PageIsLoading from '../PageIsLoading';
import EventDetailsEditor from './EventDetailsEditor';
import EventDangerZonePanel from './EventEditor/EventDangerZonePanel';
import EventEditorNavigation from './EventEditor/EventEditorNavigation';
import EventPhotoGallerySection from './EventEditor/EventPhotoGallerySection';
import { EventPhotoUploadForm } from './EventEditor/EventPhotoUploadForm';
import { useEventEditorView } from './EventEditor/useEventEditorView';

const EventEditorView: FC = () => {
    const {
        // State
        photoEvent,
        photoEventPhotos,
        eventId,
        isNewEvent,
        overlayKey,

        // Handlers
        onDeleteEventClick,
        onFilesChanged,
        onSubmitFileUpload,
        onOverlayKeyChanged,
    } = useEventEditorView();

    if (!photoEvent) {
        return <PageIsLoading />;
    }

    return (
        <Box sx={{ p: 3 }}>
            <EventEditorNavigation
                eventTitle={photoEvent.title}
                isNewEvent={isNewEvent}
            />

            {/* Event Details Section */}
            <Box className='event-gallery-admin-area-frame' sx={{ mb: 3 }}>
                <EventDetailsEditor
                    eventId={eventId}
                    parentEventId={null}
                />
            </Box>

            {/* Photo Management - Only show for existing events */}
            {!isNewEvent && (
                <>
                    <EventPhotoUploadForm
                        photoEvent={photoEvent}
                        onSubmitFileUpload={onSubmitFileUpload}
                        onFilesChanged={onFilesChanged}
                        overlayKey={overlayKey}
                        onOverlayKeyChanged={onOverlayKeyChanged}
                    />

                    <EventPhotoGallerySection
                        photoEventPhotos={photoEventPhotos}
                    />

                    <EventDangerZonePanel
                        photoEvent={photoEvent}
                        onDeleteEvent={onDeleteEventClick}
                    />
                </>
            )}
        </Box>
    );
};

export { EventEditorView };
